import React from 'react'
import * as routeLink from "./../../constants/routeLink";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import TopInfo from "./../../components/TopInfo/index";
import BalanceInfo from "./../../components/BalanceInfo/index";
import Customcard from "./../../components/Customcard/index";
import TopLevel from "./../../components/TopLevel/index";
import { useSelector } from 'react-redux';
import { formatNumber } from '../../services/services';
const Index = (props) => {
  const { apiReducer } = useSelector((state) => state);
  const { user } = apiReducer;


  const handleCopy = (type) => {
    if (type == 1) {
      let referralLink = `https://t.me/dogex_ton_bot/start?startapp=${user?.userID.replaceAll('user', '')}`;
      navigator.clipboard.writeText(referralLink)
        .then(() => {
          toast("Copied to clipboard")
          console.log(`Copied to clipboard`);
          
        })
        .catch(err => {
          toast('Failed to copy: ', err)
        });

    } else {
      share_();
    }

  };

  const share_ = () => {
    if (!user?.userID) {
      return
    }
    let referralLink = `https://t.me/dogex_ton_bot/start?startapp=${user?.userID.replaceAll('user', '')}`;
    // navigator.clipboard.writeText(referralLink)
    const telegramShareLink = `https://t.me/share/url?url=${encodeURIComponent(referralLink)}`;
    window.open(telegramShareLink, '_blank');
  }

  return (
    <div className='d-flex justify-content-center align-items-center flex-column'>


      <TopInfo />
      <TopLevel />
      <div className='w-100 d-flex justify-content-center align-items-center flex-column p-2'>
        <div className='card-custom w-100 p-3 radius-custom d-flex flex-column justify-content-center align-items-center'>
          <div className='d-flex justify-content-center align-items-center'>
            <h4 className='text-white fs-extra d-flex m-0 mx-2'>{user?.totalF1} FRIENDS</h4>
          </div>
        </div>
      </div>

      <div className='w-100 d-flex justify-content-center align-items-center flex-column p-2'>
        <div className='card-custom w-100 p-3 radius-custom d-flex flex-column justify-content-center align-items-center'>
          <div className='w-100  d-flex flex-column justify-content-center align-items-start'>
            <h4 className='text-white fs-extra d-flex m-0 mb-1'>Information</h4>
            {/* <span className='text-white'>You have your friends will recevice bonuses</span> */}

          </div>

          <div className='w-100'>
            <div className='card-custom w-100 p-3  mt-2' style={{ color: '#fff' }}>
              <div className='ssdsad2e2d'>ID: {user?.userID}</div>
              <div className='ssdsad2e2d'>Ref By: {user?.refBy || 'none'}</div>
              <div className='ssdsad2e2d'>Sales: {formatNumber(user?.directSales)}</div>
              <div className='ssdsad2e2d'>commission: {formatNumber(user?.commission)} </div>
              {/* <div className='d-flex mb-2'>
                <div className='w-50  d-flex flex-column justify-content-center align-items-start'>
                  <h4 className='text-white  d-flex m-0 mb-1'>Invite a friends</h4>
                </div>
                <div className='w-50  d-flex flex-column justify-content-center align-items-end'>
                  <div className='img' style={{ width: "50px", height: "50px" }}>
                    <img src={`${routeLink.domain}/assets/imgs/star1.png`} className='w-100 h-100 object-fit-contain ' />
                  </div>

                </div>
              </div> */}
              {/* <div className='d-flex  flex-column w-100'>
                <div className='d-flex w-100'>
                  <div className='card-icon me-2 d-flex align-items-center justify-content-center'>
                    <img className='w-100 h-100' src={`${routeLink.domain}/assets/imgs/footprintDog.png`} />
                  </div>
                  <span className='fw-bold color-sub-pri'>50,000</span>
                </div>
                <span className='text-white'>for you and friends</span>
              </div> */}
            </div>

            {/* <div className='card-custom w-100 p-3  radius-custom d-flex flex-column justify-content-center align-items-center  mt-2'>
              <div className='d-flex mb-2'>
                <div className='w-50  d-flex flex-column justify-content-center align-items-start'>
                  <h4 className='text-white  d-flex m-0 mb-1'>Invite a friends with TG premium</h4>

                </div>
                <div className='w-50  d-flex flex-column justify-content-center align-items-end'>
                  <div className='img' style={{ width: "50px", height: "50px" }}>
                    <img src={`${routeLink.domain}/assets/imgs/circel.png`} className='w-100 h-100 object-fit-contain ' />
                  </div>

                </div>
              </div>
              <div className='d-flex  flex-column w-100'>
                <div className='d-flex w-100'>
                  <div className='card-icon me-2 d-flex align-items-center justify-content-center'>
                    <img className='w-100 h-100' src={`${routeLink.domain}/assets/imgs/footprintDog.png`} />
                  </div>
                  <span className='fw-bold color-sub-pri'>25,000</span>
                </div>
                <span className='text-white'>for you and friends</span>
              </div>
            </div> */}
          </div>


        </div>


      </div>

      <div className='w-100 d-flex justify-content-center align-items-center p-2'>
        <button className='d-flex justify-content-center align-items-center  scale_btn btn btn-custom-2 w-75 me-2' onClick={() => handleCopy(2)}>
          <div className='me-2'>
            <img src={`${routeLink.domain}/assets/imgs/user-add-icon.png`} className=' object-fit-contain ' style={{ width: "30px", height: "30px" }} />
          </div>
          <span className='text-white fw-bold'>Invite a friends</span>
        </button>

        <button className='d-flex justify-content-center align-items-center scale_btn btn btn-custom-2 w-15' onClick={() => handleCopy(1)}>
          <div className='me-2'>
            <img src={`${routeLink.domain}/assets/imgs/copy-icon.png`} className=' object-fit-contain ' style={{ width: "30px", height: "30px" }} />
          </div>
        </button>
      </div>
    </div>
  )
}

export default Index;
